import { Suspense, useState } from "react"
import { DownArrow } from "shared-components/Components/CustomIcons/DownArrow/web"
import { useFilters } from "shared-components/Components/Filters/Filters.hook"
import { Modal } from "shared-components/Components/Modal/web"
import { AmenitiesDataOptionsTypes } from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/types"
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook"
import { amenities } from "../options"
import "./styles.less"
import React from "react"

export const Amenities = () => {
    const { filters } = useFilters()
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters()
    const [activeTab, setActiveTab] = useState("all")
    const [searchValue, setSearchValue] = useState("")
    const [sowModalAmenities, setShowModalAmenities] = useState(false)
    const filteredAmenities = activeTab === "all"
        ? amenities.filter(item => item.text.toLowerCase().includes(searchValue.toLowerCase()))
        : amenities.filter(item => item.grupo === activeTab && item.text.toLowerCase().includes(searchValue.toLowerCase()));
    const uniqueGroups = [...new Set(amenities.map(item => item.grupo))];

    const watchCheckedInFilter = (filterTypeObj, filterType) => {
        return filterTypeObj ? filterTypeObj.map((val) => ({ ...val, value: val.value, text: val.text, checked: filterType?.includes(val.value) })) : []
    }

    const removeAmeneties = (value) => {
        if (filters.facilitiesGroup) {
            let newOptions = filters.facilitiesGroup.filter((e) => e != value)
            let newFilters = amenitiesList.filter((e) => newOptions.includes(e.value)).map((e) => ({ value: e.value, text: e.text }))
            changeFilters({ facilitiesGroup: newFilters })
        }
    }

    const handleAmenities = (value) => {
        if (amenitiesList.length) {
            let newOptions = amenitiesList?.map((item) =>
                item.value == value ? { ...item, checked: !item.checked } : item
            );

            let newFilters = newOptions
                .filter((v) => v.checked)
                .map((e) => ({ value: e.value, text: `con ${e.text}` }));
            changeFilters({ facilitiesGroup: newFilters });
        }
    }

    const amenitiesList: AmenitiesDataOptionsTypes[] = watchCheckedInFilter(amenities, filters?.facilitiesGroup)

    return (
        <div className="otherFilters__container filter facilities-filter" id="ameneties">
            <div className="container-title" onClick={() => setShowModalAmenities(true)}>
                <span className="text">Amenities</span>
                <span className="icon"><DownArrow /></span>
            </div>

            <Modal
                onSuccess={() => { }}
                show={sowModalAmenities}
                width="800px"
                title="Selecciona las Amenities"
                onClose={() => setShowModalAmenities(false)}
            >
                <div>
                    <input
                        type="text"
                        placeholder="Buscá por palabra"
                        className="search-amenities"
                        onChange={(e) => setSearchValue(e.target.value)}
                    />

                    <ul className="nav-amentities nav-tabs">
                        <li
                            className={`nav-item ${activeTab === "all" ? "active" : ""}`}
                            onClick={() => setActiveTab("all")}
                        >
                            Todos
                        </li>
                        {uniqueGroups.map(group => {
                            const counter = (amenities && filters.facilitiesGroup) ? amenities.filter(item => item.grupo === group && filters.facilitiesGroup.includes(item.value)).length : 0

                            return (
                                <li
                                    key={group}
                                    className={`nav-item ${activeTab === group ? "active" : ""}`}
                                    onClick={() => setActiveTab(group)}
                                >
                                    {counter > 0 &&
                                        <div className="counter">
                                            {counter}
                                        </div>
                                    }

                                    {group}
                                </li>
                            )
                        })}
                    </ul>

                    <div className="amenities-container-modal">
                        {amenitiesList && filteredAmenities.map((val, i) => {
                            return (
                                <div
                                    key={'ameneties-' + i}
                                    className={"pill " + (filters.facilitiesGroup && filters.facilitiesGroup.includes(val.value) ? 'active' : '')}
                                    onClick={() => handleAmenities(val.value)}
                                >
                                    <Suspense fallback={<div>...</div>}>
                                        {React.createElement(React.lazy(val.icon))}
                                    </Suspense>
                                    <span className="text">{val.text}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Modal>
        </div>
    )
}